import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PostSalesCorporateV2Edit from "./corporate";
import { locationPinCode,shipTolocationPinCode } from "services/redux/sales/corporate/locations/action";
import { postSalesCorporateLeadNew,postSalesClientData,postSalesAdvancePayments,postSolutionProduct,postSalesInstallation,postSalesInvoiceModule,postSalesMileStone,getSalesCorporateLeadNew,getInventoryMasterData, postCapexInvoiceModule,contractInvoicePreview} from "services/redux/sales/postSales/contractNew/action";
import { clientBillingAddress } from "services/redux/sales/corporate/client/action";
import {getContractRevenue, getContractService, getRevenueNature, checkManagementFeeApplicable} from "../../../../services/redux/sales/postSales/action";

import {
  postCorporate,
  getMateriaById,
  getBrandById,
  getTagById,
} from "services/redux/sales/postSales/contractCorporate/action";
import {
  documentUploadUrl,
  imageUploadUrl,
  videoUploadUrl,
} from "services/redux/fileUpload/action";
import { supplyNameFun } from "services/redux/sales/corporate/categoryDetails/action";
import {getRequiredDocumentsDropdown} from "services/redux/installation/tagDelivery/action";
import { userRoleBasedDropdown, saveExternalUserData } from "services/redux/tickets/createTicket/action";
import {documentUploadUrlPublic} from "services/redux/fileUpload/action";

const mapStateToProps = (state) => ({
  postCorData: state.coporatePostLeadReducer.postCorData,
  pincodeData: state.locationReducer.pincodeData,
  getMaterial: state.coporatePostLeadReducer.getMaterial,
  getBrand: state.contractCorporateReducer.getBrand,
  getTag: state.coporatePostLeadReducer.getTagById,
  documentUrlData: state.fileUploadReducer.documentUrlData,
  splNameData: state.categoryDetlReducer.splNameData,
  shipToPincodeData:  state.locationReducer.shipToPincodeData,
  clientBillingPocData: state.clientReducer.billingAddressPoc,
  contractRevenueDetails: state.postSalesReducer.contractRevenueDetails,
  contractCatService: state.postSalesReducer.contractCatService,
  postSalesData:state.contractNewReducer.postSalesData,
  revenueNature: state.postSalesReducer.revenueNature,
  managementFeeApplicable: state.postSalesReducer.managementFeeApplicable,
  getUserBasedDropdown: state.createTicketReducer.getUserBasedDropdown,
  insertExternalUser: state.createTicketReducer.insertExternalUser,
  inventoryData:state.contractNewReducer.inventoryMasterData,
  requiredDocumentsDropdown: state.tagDeliveryReducer.requiredDocumentsDropdown,
  documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      postCorporate,
      locationPinCode,
      postSalesCorporateLeadNew,
      postSolutionProduct,
      postSalesInstallation,
      postSalesInvoiceModule,
      postSalesMileStone,
      getMateriaById,
      getBrandById,
      getTagById,
      documentUploadUrl,
      imageUploadUrl,
      videoUploadUrl,
      supplyNameFun,
      shipTolocationPinCode,
      clientBillingAddress,
      getContractRevenue,
      getContractService,
      postSalesClientData,
      postSalesAdvancePayments,
      getSalesCorporateLeadNew,
      getRevenueNature,
      checkManagementFeeApplicable,
      userRoleBasedDropdown,
      saveExternalUserData,
      getInventoryMasterData,
      getRequiredDocumentsDropdown,
      documentUploadUrlPublic,
      postCapexInvoiceModule,
      contractInvoicePreview
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PostSalesCorporateV2Edit);
